import { useContext } from 'react';
import MainAppContext from 'contexts/MainAppContext';
import LayerView from './components/Views/LayerView';
import TileView from './components/Views/TileView';

function MapModeView() {
  const { viewMode } = useContext(MainAppContext);

  return viewMode === 'layer' ? <LayerView /> : <TileView />;
}

export default MapModeView;
